module.exports = __webpack_public_path__ + "img/home.12b791d3.jpg";